export default "__VITE_ASSET__CeBas$xU__"